import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferSupplierPricing {
  constructor($scope, OfferService) {
    $scope.load_items = function() {
      $scope.loading = true;
      $scope.items = [];
      OfferService.get_supplier_pricing_stocklist(window.offer_id, $scope.country_id).success(function(data) {
        if (data.success) {
          $scope.items = data.items;
          $scope.fields = data.fields;
          $scope.has_reels = _.select(data.items, function(i) {
            return i.is_reels === true;
          }).length > 0;
          $scope.has_sheets = _.select(data.items, function(i) {
            return i.is_reels === false;
          }).length > 0;
          $scope.loading = false;
        }
      });
    };

    $scope.$watch('country_id', function() {
      $scope.supplier_freight_rates = [];
      $scope.country_extra_charge = null;
      if ($scope.country_id && $scope.country_id > 0) {
        OfferService.get_freight_rates_for_buyer(window.offer_id, $scope.country_id).then(function(data) {
          $scope.supplier_freight_rates = data.freight_rates;
          return OfferService.get_country_extra_charge(window.offer_id, window.supplier_id, $scope.country_id);
        }).then(function(data) {
          $scope.country_extra_charge = data.country_extra_charge;
        });
      }
    });

    $scope.check_items = function(is_reels) {
      angular.forEach($scope.items, function(item) {
        if (is_reels && item.is_reels)
          item.checked = $scope.reels_checked;
        else if (!is_reels && !item.is_reels)
          item.checked = $scope.sheets_checked;
      });
    };

    $scope.edit_item_price = function(item) {
      $scope.show_edit_price([item]);
    };

    $scope.edit_item_prices = function() {
      var items = [];
      _.each($scope.items, function(item) {
        if (item.checked)
          items.push(item);
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        $scope.show_edit_price(items);
      }
    };

    $scope.show_edit_price = function(items) {
      $scope.edit_items = items;
      $.fancybox($('div#mass_edit_prices'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    };

    $scope.submit_edit_price = function() {
      if ($scope.edit_price > 0) {
        var items = _.pluck($scope.edit_items, 'id');
        $scope.submitting = true;
        OfferService.update_stock_items_price(window.offer_id, items, $scope.edit_price, $scope.edit_incoterm, $scope.country_id || null).success(function(data) {
          if (data.success) {
            _.each($scope.edit_items, function(item) {
              item.fca = data.prices.exw;
              item.cfr = data.prices.cfr;
              item.dap = data.prices.dap;
            });
            $scope.submitting = false;
            $.fancybox.close();
          }
        });
      }
    };

    $scope.quick_search = function() {
      window.filter_table('table#reels', $scope.query);
      window.filter_table('table#sheets', $scope.query);
    };

    $scope.show_row = function(item) {
      var offer = false;
      if ($scope.filter_offer == '0') {
        offer = true;
      } else if ($scope.filter_offer == '1' && (item.offer_fca || item.offer_cfr || item.offer_dap)) {
        offer = true;
      } else if ($scope.filter_offer == '2' && (!item.offer_fca && !item.offer_cfr && !item.offer_dap)) {
        offer = true;
      }

      var order = false;
      if ($scope.filter_order == '0') {
        order = true;
      } else if ($scope.filter_order == '1' && (item.order_fca || item.order_cfr || item.order_dap)) {
        order = true;
      } else if ($scope.filter_order == '2' && (!item.order_fca && !item.order_cfr && !item.order_dap)) {
        order = true;
      }

      var ospp = false;
      if ($scope.filter_ospp == '0') {
        ospp = true;
      } else if ($scope.filter_ospp == '1' && (item.ospp_fca || item.ospp_cfr || item.ospp_dap)) {
        ospp = true;
      } else if ($scope.filter_ospp == '2' && (!item.ospp_fca && !item.ospp_cfr && !item.ospp_dap)) {
        ospp = true;
      }

      var country_order = false;
      if ($scope.filter_country_order == '0') {
        country_order = true;
      } else if ($scope.filter_country_order == '1' && (item.order_country_fca || item.order_country_cfr || item.order_country_dap)) {
        country_order = true;
      } else if ($scope.filter_country_order == '2' && (!item.order_country_fca && !item.order_country_cfr && !item.order_country_dap)) {
        country_order = true;
      }

      var country_ospp = false;
      if ($scope.filter_country_ospp == '0') {
        country_ospp = true;
      } else if ($scope.filter_country_ospp == '1' && (item.ospp_country_fca || item.ospp_country_cfr || item.ospp_country_dap)) {
        country_ospp = true;
      } else if ($scope.filter_country_ospp == '2' && (!item.ospp_country_fca && !item.ospp_country_cfr && !item.ospp_country_dap)) {
        country_ospp = true;
      }

      return offer && order && ospp && country_order && country_ospp;
    };

    $scope.show_field = function(field) {
      if (field.id == 'fca')
        return $scope.show_fca;
      else if (field.id == 'cfr')
        return $scope.show_cfr;
      else if (field.id == 'dap')
        return $scope.show_dap;
      else
        return true;
    };

    $scope.edit_incoterms = [
      {
        id: 3,
        name: 'FCA'
      },
      {
        id: 1,
        name: 'CFR'
      },
      {
        id: 2,
        name: 'DAP'
      },
    ];

    $scope.copy_to_fca = function(source) {
      var items = [];
      _.each($scope.items, function(item) {
        if (item.checked)
          items.push(item);
      });
      if (items.length === 0) {
        alert('Please select at least one item!');
      } else {
        var updated_items = [];
        _.each(items, function(item) {
          var exw = item[source] || null;
          if (exw && source == 'order_fca') {
            if (item.order_charge)
              exw = exw - item.order_charge;
            else
              exw = exw - $scope.order_charge;
          } else if (exw && source == 'order_country_fca') {
            exw = exw - $scope.order_charge;
          } else if (exw && source == 'ospp_fca') {
            if (item.ospp_charge)
              exw = exw - item.ospp_charge;
            else
              exw = exw - $scope.order_charge;
          }
          updated_items.push({
            id: item.id,
            exw: exw
          });
        });
        $scope.updating = true;
        OfferService.update_stock_items_fca(updated_items).success(function(data) {
          if (data.success) {
            $scope.load_items();
            $scope.updating = false;
          }
        });
      }
    };

    $scope.init = function() {
      $scope.supplier_id = window.supplier_id;
      $scope.load_items();
      $scope.countries = window.countries;
      $scope.edit_incoterm = 3;
      $scope.show_offer = true;
      $scope.show_order = true;
      $scope.show_ospp = true;
      $scope.show_ospp_country = false;
      $scope.show_fca = true;
      $scope.show_cfr = true;
      $scope.show_dap = true;
      $scope.filter_offer = '0';
      $scope.filter_order = '0';
      $scope.filter_ospp = '0';
      $scope.filter_country_order = '0';
      $scope.filter_country_ospp = '0';
      $scope.order_charge = 0;
    };

    $scope.init();

  }
}

OfferSupplierPricing.$inject = ['$scope', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-supplier-pricing.ctrl.js